
export const PRODUCT_QUANTITY_ADD_REQUEST = "PRODUCT_QUANTITY_ADD_REQUEST";
export const PRODUCT_QUANTITY_ADD_SUCCESS = "PRODUCT_QUANTITY_ADD_SUCCESS";
export const PRODUCT_QUANTITY_ADD_FAILURE = "PRODUCT_QUANTITY_ADD_FAILURE";

export const PRODUCT_QUANTITY_EDIT_REQUEST = "PRODUCT_QUANTITY_EDIT_REQUEST";
export const PRODUCT_QUANTITY_EDIT_SUCCESS = "PRODUCT_QUANTITY_EDIT_SUCCESS";
export const PRODUCT_QUANTITY_EDIT_FAILURE = "PRODUCT_QUANTITY_EDIT_FAILURE";

export const PRODUCT_QUANTITY_VIEW_REQUEST = "PRODUCT_QUANTITY_VIEW_REQUEST";
export const PRODUCT_QUANTITY_VIEW_SUCCESS = "PRODUCT_QUANTITY_VIEW_SUCCESS";
export const PRODUCT_QUANTITY_VIEW_FAILURE = "PRODUCT_QUANTITY_VIEW_FAILURE";

export const PRODUCT_QUANTITY_VIEW_ALL_REQUEST = "PRODUCT_QUANTITY_VIEW_ALL_REQUEST";
export const PRODUCT_QUANTITY_VIEW_ALL_SUCCESS = "PRODUCT_QUANTITY_VIEW_ALL_SUCCESS";
export const PRODUCT_QUANTITY_VIEW_ALL_FAILURE = "PRODUCT_QUANTITY_VIEW_ALL_FAILURE";

export const PRODUCT_QUANTITY_SEARCH_REQUEST = "PRODUCT_QUANTITY_SEARCH_REQUEST";
export const PRODUCT_QUANTITY_SEARCH_SUCCESS = "PRODUCT_QUANTITY_SEARCH_SUCCESS";
export const PRODUCT_QUANTITY_SEARCH_FAILURE = "PRODUCT_QUANTITY_SEARCH_FAILURE";

export const PRODUCT_QUANTITY_DELETE_REQUEST = "PRODUCT_QUANTITY_DELETE_REQUEST";
export const PRODUCT_QUANTITY_DELETE_SUCCESS = "PRODUCT_QUANTITY_DELETE_SUCCESS";
export const PRODUCT_QUANTITY_DELETE_FAILURE = "PRODUCT_QUANTITY_DELETE_FAILURE";

export const  PRODUCT_QUANTITY_RESET_STATE = " PRODUCT_QUANTITY_RESET_STATE";